@if (isLoading$ | async) {
  <!-- clicks wait while something loads; nothing is dimmed -->
  <div class="loader-shield" role="status" aria-live="polite">
    <div class="loader-bar" aria-hidden="true"><span></span></div>
    <div class="loader-pill">
      <span class="loader-dot" aria-hidden="true"></span>
      {{ message$ | async }}
    </div>
  </div>
}
